import { useEffect } from "react";

// Please use this hook if you only need to execute the function once when mounting the component.
export default function useComponentDidMount(f: () => void) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => f(), []);
}
